import { intlLocale } from "..";

export default function formatPrice(amount: number, currency: string) {
  if (!currency) {
    return amount;
  }
  return new Intl.NumberFormat(intlLocale, {
    style: "currency",
    currency,
  }).format(amount);
}

export function isEventFree(price: Price) {
  if (!price) {
    return true;
  }
  const { amount = 0 } = price;
  return amount === 0;
}

type Price = {
  amount: number;
  currencyCode: string;
};
export const formatEventPrice = (price: Price, t: Function) => {
  const amount = price?.amount || 0;
  const currencyCode = price?.currencyCode;
  if (isEventFree(price)) {
    return t("event.free");
  }

  return `${formatPrice(amount, currencyCode)} ${t("event.pp")}`;
};
